// Front end javascript file
// you might want to have everything within one of these bad boys:
// window.addEventListener('load', (event) => { --> code here <-- });

addEventListener("DOMContentLoaded", (event) => {

 document.querySelector("#jcc-content-back-button--front a").addEventListener("click", () => {
  history.back();
 });

});